import { PublishedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { IDesignProjectId, IDesignProjectCategoryId } from '../../interfaces/DesignProject';
import additionalDataFactory from './common/fieldsAdditionalData';
import budgetMarksBuilder from './common/budgetMarksBuilder';

const dpChildBedroomLayoutForm: IForm = {
    formId       : PublishedFormId.ChildBedroomLayout,
    type         : FormTypeId.DesignProject,
    thumbnailURL : '/resized-images/forms/dpChildBedroomLayout.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.DesignProject,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        designProject: {
            [IDesignProjectCategoryId.Bedding]: {
                [IDesignProjectId.ClassicBed]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.CabinBed]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.BunkBed]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.MezzanineBed]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Bedding]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Bedhead]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.GroundMattress]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
            },
            [IDesignProjectCategoryId.Seated]: {
                [IDesignProjectId.Chair]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Armchair]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Stool]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Bench]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.BenchLong]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
            },
            [IDesignProjectCategoryId.StorageUnit]: {
                [IDesignProjectId.Library]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.ArmorWardrobe]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Wardrobe]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Cupboard]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.ToyBox]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Dresser]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.NightStand]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
            },
            [IDesignProjectCategoryId.OfficeWorkSpace]: {
                [IDesignProjectId.Desk]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.OfficeChair]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.MobileBoxes]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
            },
            [IDesignProjectCategoryId.Decoration]: {
                [IDesignProjectId.LightFixture]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Mirror]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Carpet]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.CurtainsAndNetCurtains]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.GreenWall]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
                [IDesignProjectId.Wallpaper]: {
                    value : undefined,
                    min   : 0,
                    max   : 10,
                },
            },
            [IDesignProjectCategoryId.Ground]: {
                [IDesignProjectId.TiledFloor]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
                [IDesignProjectId.WaxedConcreteFloor]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
                [IDesignProjectId.ParquetFloor]: {
                    value : undefined,
                    min   : 0,
                    max   : 1000,
                },
            },
        },
        additionalData: additionalDataFactory({
            budgetMin          : 2000,
            budgetMax          : 250000,
            budgetDefaultValue : 15000,
            marks              : budgetMarksBuilder(2000, 1000, 50000, 5000, 250000),
            hasQuantity        : false,
        }),
        contact: fieldsContact,
    },
};

export default dpChildBedroomLayoutForm;
